import { categoryStore } from '@/store';
import { analyticsMixin } from './analytics';
import { quizStore } from '@/store';

export const partnerDescriptionTypes = {
    none: 0,
    members: 1,
    pricing: 2,
    introductionTitle: 3,
    introduction: 4,
};

export const partnerDescriptionDetailTypes = {
    type0: 0,
    type1: 1,
    type2: 2,
    type3: 3,
};

export const partnerMixin = {
    data() {
        return {
            quizStore: quizStore,
            partnerFlag:
                this.index === 0 && !!categoryStore.state.category.category_flag
                    ? categoryStore.state.category.category_flag
                    : this.partner
                    ? this.partner.flag
                    : null,
        };
    },
    mixins: [analyticsMixin],
    computed: {
        showPartner() {
            if (window['__storybook__']) return true;
            return (
                this.showPartners.length === 0 ||
                this.showPartners.indexOf(
                    this.partner['partner_id'].toString()
                ) >= 0
            );
        },
        isEasySignUp() {
            if (!this.$globalConstants.host['easy_sign_up']) return false;
            return (
                this.partner['marketing_properties']['easy_sign_up'] &&
                this.partner['marketing_properties']['easy_sign_up'] === 'yes'
            );
        },
    },
    methods: {
        ctaText(text) {
            return this.$t(
                this.partner['cta_button_text']
                    ? this.partner['cta_button_text']
                    : this.$globalConstants.host['article_cta_text']
                    ? this.$globalConstants.host['article_cta_text']
                    : !this.isActivePartner()
                    ? 'Currently Unavailable'
                    : text
            );
        },
        clickOutCheck(location) {
            return this.clickout(
                'default',
                this.partner.clicked_partner_name,
                this.index,
                location
            );
        },
        isPartnerDisabled() {
            return Boolean(this.partner['is_disabled']);
        },
        isActivePartner() {
            return (
                !(this.partner.marketing_properties?.partner_active === 'no') &&
                !this.isPartnerDisabled()
            );
        },
        getPartnerInfoDetails(infoDetailsType) {
            switch (true) {
                // show nothing
                case infoDetailsType === partnerDescriptionDetailTypes.type0:
                    return null;
                // show intro title and 3 pullet points
                case infoDetailsType === partnerDescriptionDetailTypes.type1:
                    return this.showIntroduction();
                // show only 3 pullet points
                case infoDetailsType === partnerDescriptionDetailTypes.type2:
                    return this.partnerList();
                // show all
                case infoDetailsType === partnerDescriptionDetailTypes.type3:
                    return this.partner.introduction;
                default:
                    return this.showIntroduction();
            }
        },
        getPartnerInfo(infoType) {
            switch (true) {
                case infoType === partnerDescriptionTypes.members:
                    return this.partner.members;
                case infoType === partnerDescriptionTypes.pricing:
                    return this.partner.pricing;
                case infoType === partnerDescriptionTypes.introductionTitle:
                    return this.partnerText();
                case infoType === partnerDescriptionTypes.introduction:
                    return this.getPartnerInfoDetails();
                case infoType === partnerDescriptionTypes.none:
                    return null;
                default:
                    return this.partner.members;
            }
        },
        partnerList() {
            return this.showIntroduction().substring(
                this.showIntroduction().lastIndexOf('<ul>'),
                this.showIntroduction().lastIndexOf('</ul>') + 5
            );
        },
        partnerText() {
            return this.showIntroduction().substring(
                0,
                this.showIntroduction().lastIndexOf('<ul>')
            );
        },
        showPrice() {
            if (
                this.$globalConstants.host['show_partner_price'] &&
                this.partner['marketing_properties'] &&
                this.partner['marketing_properties']['price_in_a_partner_row']
            ) {
                return this.partner['marketing_properties'][
                    'price_in_a_partner_row'
                ];
            }
            return null;
        },
        showIntroduction() {
            let searchStr = '</li>';
            let searchStrLen = searchStr.length;
            let startIndex = 0,
                indexOf = 0,
                index,
                indices = [];
            const introduction = this.partner['introduction'];

            if (!introduction) {
                return '';
            }

            if (
                this.isFirstPartner ||
                introduction.indexOf(searchStr, startIndex) < 0
            ) {
                return introduction;
            }

            while ((index = introduction.indexOf(searchStr, startIndex)) > -1) {
                indices.push(index);
                startIndex = index + searchStrLen;
            }
            indexOf =
                indices.length > 3 ? indices[2] : indices[indices.length - 1];

            return introduction
                .substring(0, indexOf + searchStrLen)
                .concat('</ul>');
        },
        autoExpandPartnerRow() {
            try {
                if (
                    (window.__host__['first_partner_open'] &&
                        this.index === 0) ||
                    window.__host__['boxes_open']
                ) {
                    setTimeout(() => this.toggleExpandedRow(), 300);
                }
            } catch (e) {
                console.log('failed to apply the partner auto open logic');
            }
        },
    },
};
